import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'
import { vtMockId } from '@/testing/vt-test-utils'

export const accountingUnitResponseMock =
    (): AccountingUnitResponse => ({
        id: vtMockId(),
        active: true,
        isDefault: false,
        code: 'EUR',
        name: 'Euro',
        symbol: '€'
    })
